export interface ILenderInformation {
  id: string | null;
  name: string | null;
  bulkRateQualified: boolean | null;
  mortgageeClause: string | null;
}

export interface ILenderData {
  addressId: string;
  bulkRateQualified: boolean;
  coBranded: boolean;
  createdAt: string;
  defaultFeeType: eLenderFeeType;
  id: string;
  logoUrl?: string;
  masterEmail?: string;
  mortgageeClause?: string;
  name: string;
  refiDiscountedClosingFee: boolean;
  updatedAt: string;
  wfgId?: string;
}

export enum eLenderFeeType {
  Premium = 'premium',
  ReportFee = 'report_fee',
}

export const prettyLenderFeeType: Record<eLenderFeeType, string> = {
  [eLenderFeeType.Premium]: 'Premium',
  [eLenderFeeType.ReportFee]: 'Search Report',
};
